var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppSystemSchemePreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 209,
  height: 138,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-system-scheme-preview_svg__a)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-system-scheme-preview_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 208,
  height: 138,
  x: 0.333,
  fill: "#3A3A3A",
  rx: 8
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#app-system-scheme-preview_svg__c)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-system-scheme-preview_svg__d)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 212,
  height: 124,
  x: 24.334,
  y: 24,
  fill: "#fff",
  fillOpacity: 0.035,
  rx: 8,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-system-scheme-preview_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.334 24h75.999v124h-76z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.035,
  d: "M24.334 24h75.999v124h-76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M99.334 24v124h1.999V24z",
  mask: "url(#app-system-scheme-preview_svg__e)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 32.334,
  y: 34,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 80.334,
  y: 34,
  fill: "#555",
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 72,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 84,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 96,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 108,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 120,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 48.334,
  y: 38,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 42.334,
  y: 73,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 4,
  x: 42.334,
  y: 85,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 4,
  x: 42.334,
  y: 97,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 4,
  x: 42.334,
  y: 109,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 4,
  x: 42.334,
  y: 121,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 10,
  x: 32.334,
  y: 54,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-system-scheme-preview_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.333 24h132v30h-132z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.035,
  d: "M100.333 24h132v30h-132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M232.333 53h-132v2h132z",
  mask: "url(#app-system-scheme-preview_svg__f)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 108.333,
  y: 34,
  fill: "#555",
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 122.333,
  y: 37,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 4,
  x: 108.333,
  y: 62,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.833,
  y: 72.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.833,
  y: 114.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 180.333,
  y: 62,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 180.833,
  y: 72.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 180.833,
  y: 114.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}))))), /*#__PURE__*/React.createElement("mask", {
  id: "app-system-scheme-preview_svg__g",
  width: 251,
  height: 302,
  x: -111,
  y: -87,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "m-110.601 155.807 88.241-242.44 161.627 58.827-88.24 242.44z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#app-system-scheme-preview_svg__g)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 205,
  height: 138,
  x: 0.333,
  fill: "#F9F9F9",
  rx: 8
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#app-system-scheme-preview_svg__h)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-system-scheme-preview_svg__i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 219,
  height: 173,
  x: 24.334,
  y: 24,
  fill: "#F9F9F9",
  rx: 8
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-system-scheme-preview_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.334 24h75.999v173h-76z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.334 24h75.999v173h-76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M99.334 24v173h1.999V24z",
  mask: "url(#app-system-scheme-preview_svg__j)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 32.334,
  y: 34,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 80.334,
  y: 34,
  fill: "#F0F0F0",
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 72,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 84,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 96,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 108,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.334,
  y: 120,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 48.334,
  y: 38,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 42.334,
  y: 73,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 4,
  x: 42.334,
  y: 85,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 4,
  x: 42.334,
  y: 97,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 4,
  x: 42.334,
  y: 109,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 4,
  x: 42.334,
  y: 121,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 10,
  x: 32.334,
  y: 54,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-system-scheme-preview_svg__k",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.333 24h132v30h-132z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M100.333 24h132v30h-132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M232.333 53h-132v2h132z",
  mask: "url(#app-system-scheme-preview_svg__k)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 108.333,
  y: 34,
  fill: "#F0F0F0",
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 122.333,
  y: 37,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 4,
  x: 108.333,
  y: 62,
  fill: "#000",
  fillOpacity: 0.06,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 108.333,
  y: 72,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.833,
  y: 72.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 108.333,
  y: 114,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.833,
  y: 114.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
})))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "app-system-scheme-preview_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.333 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.61.654C4.893 0 6.573 0 9.934 0h188.799c3.361 0 5.041 0 6.324.654a6 6 0 0 1 2.623 2.622c.653 1.284.653 2.964.653 6.324v118.8c0 3.36 0 5.04-.653 6.324a6 6 0 0 1-2.623 2.622c-1.283.654-2.963.654-6.324.654H9.933c-3.36 0-5.04 0-6.323-.654a6 6 0 0 1-2.623-2.622C.333 133.44.333 131.76.333 128.4z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "app-system-scheme-preview_svg__b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 208,
  height: 138,
  x: 0.333,
  fill: "#fff",
  rx: 8
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "app-system-scheme-preview_svg__d"
}, /*#__PURE__*/React.createElement("rect", {
  width: 212,
  height: 124,
  x: 24.334,
  y: 24,
  fill: "#fff",
  rx: 8
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "app-system-scheme-preview_svg__i"
}, /*#__PURE__*/React.createElement("rect", {
  width: 219,
  height: 173,
  x: 24.334,
  y: 24,
  fill: "#fff",
  rx: 8
})), /*#__PURE__*/React.createElement("filter", {
  id: "app-system-scheme-preview_svg__c",
  width: 276,
  height: 188,
  x: -11.666,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_507_3329"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_507_3329",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "app-system-scheme-preview_svg__h",
  width: 283,
  height: 237,
  x: -11.666,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_507_3329"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_507_3329",
  result: "shape"
})))));
export { SvgAppSystemSchemePreview as ReactComponent };
export default "data:image/svg+xml;base64,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";